import React from 'react';
import { Spinner } from '@seismic/mantle';
import classNames from 'classnames';

const LoadingIcon =
  ({ isPostToChannels, isTryAgain }) =>
  () => {
    const showBorder = isPostToChannels || isTryAgain;
    return (
      <>
        <div
          className={classNames('mt-10', {
            'border-right': showBorder,
            'h-14': showBorder,
            'pr-5': showBorder,
          })}
        >
          <Spinner size={16} className="mt--9" />
        </div>
      </>
    );
  };

export default LoadingIcon;
